import styled from 'styled-components';
import ImageCropper from '../../../app/components/imageCropper/ImageCropper';
import { Modal } from 'react-bootstrap';
import Gallery from './Gallery';
import { BtnOutlineDefault } from '../../../app/components/styledComponents/StyledCustomButton';
import StyledButton from '../../../app/components/styledComponents/StyledButton';

const ImageSelectionModal = ({
  cropActive,
  showCropperModal1,
  setShowCropperModal1,
  imgBase64,
  setCroppedImage,
  cropSize,
  openImageGalleryModal,
  setOpenImageGalleryModal,
  setSelectedImage,
  handleAddImages,
  selectMulti = false,
}) => {
  return (
    <ModalContainer>
      {cropActive && showCropperModal1 && (
        <ImageCropper
          imageData={imgBase64}
          editingDone={setCroppedImage}
          size={cropSize}
          cancelPopup={() => setShowCropperModal1(false)}
          showCropperModal1={showCropperModal1}
        />
      )}
      <Modal
        show={openImageGalleryModal}
        size="xl"
        dialogClassName="modal-xxl"
        scrollable={true}
      >
        <Modal.Body id="imageSelection" className="">
          <Gallery
            comingFrom={'imageSelection'}
            selectedImage={setSelectedImage}
            selectMulti={selectMulti}
          />
        </Modal.Body>
        <Modal.Footer>
          <BtnOutlineDefault onClick={() => setOpenImageGalleryModal(false)}>
            {' '}
            Cancel{' '}
          </BtnOutlineDefault>
          {handleAddImages && (
            <StyledButton onClick={() => handleAddImages()}>
              {' '}
              Done{' '}
            </StyledButton>
          )}
        </Modal.Footer>
      </Modal>
    </ModalContainer>
  );
};

const ModalContainer = styled.div`
  .modal.modal-fullscreen .modal-dialog {
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    max-width: none;
  }

  .modal.modal-fullscreen .modal-content {
    height: auto;
    height: 100vh;
    border-radius: 0;
    border: none;
  }

  .modal.modal-fullscreen .modal-body {
    overflow-y: auto;
  }
`;

export default ImageSelectionModal;
